import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  /**
  * Retorna uma lista ordenada crescentemente
  * @param lista que será ordenada
  * @param propridade (opcional) caso a lista seja de objetos complexos, propriedade pela qual se deseja ordenar a lista
  */
  public sortBy(lista: any[], propridade: string | null = null): any[] {
    if (propridade === null)
      return lista.sort((a, b) => a > b ? 1 : a === b ? 0 : -1);
    return lista.sort((a, b) => a[propridade] > b[propridade] ? 1 : a[propridade] === b[propridade] ? 0 : -1);
  }

  /**
  * Retorna uma lista ordenada decrescentemente
  * @param lista que será ordenada
  * @param propridade (opcional) caso a lista seja de objetos complexos, propriedade pela qual se deseja ordenar a lista
  */
  public sortByDescending(lista: any[], propridade: string | null = null): any[] {
    if (propridade === null) return lista.sort((a, b) => a < b ? 1 : a === b ? 0 : -1);
    else return lista.sort((a, b) => a[propridade] < b[propridade] ? 1 : a[propridade] === b[propridade] ? 0 : -1);
  }

  /**
  * Retorna o objeto passado como parâmetro ou '-' caso seja um valor invalido
  * @param valor que será verificado
  */
  public getValueOrDash(valor: string): string {
    if (valor === null || valor === undefined || valor === "")
      return "-";

    return valor;
  }

  /**
  * Retorna uma copia do map passado como parâmetro
  * @param map Map que será copiada
  */
  public deepCopyMap<T1, T2>(map: Map<T1, T2>): Map<T1, T2> {
    const newMap = new Map();

    const iterator = map.entries();

    for (const item of iterator) {
      const [key, obj] = item;
      newMap.set(key, this.deepCopy(obj));
    }

    return newMap;
  }

  /**
  * Retorna uma copia do objeto passado como parâmetro, independentemente da complexidade do objeto
  * @param obj Objeto que será copiado
  */
  public deepCopy(obj: any): any {
    let copy: any;

    // Handle the 3 simple types, and null or undefined
    if (null === obj || "object" !== typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepCopy(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (const attr in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, attr))
          copy[attr] = this.deepCopy(obj[attr]);
      }
      return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }

  /**
  * Retorna um booleano informando se ocorreu overflow no objeto passado como parâmetro
  * @param el Objeto que se deseja saber se houve overflow
  */
  public isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible")
      el.style.overflow = "hidden";
    const isOverflowing = el.clientWidth < el.scrollWidth
      || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  /**
  * Retorna a chave de um Map a partir do valor
  * @param map Objeto onde a busca será feita
  * @param searchValue Valor que se deseja obter a chave do Map
  * @param searchProperty (optional) Caso o valor do map seja um objeto complexo, a propriedade do objeto que será usada para comparação
  */
  public getMapKeyByValue(map: Map<any, any>, searchValue: any, searchProperty: string | null = null): any {
    if (searchProperty === null) {
      for (const [key, value] of map.entries()) {
        if (value === searchValue)
          return key;
      }
    }
    else {
      for (const [key, value] of map.entries()) {
        if (value[searchProperty] === searchValue[searchProperty])
          return key;
      }
    }

    return null;
  }

  public completaComZeros(numero: string | number, size: number = 12): string {
    let stringNumber = numero + "";
    while (stringNumber.length < size) stringNumber = "0" + stringNumber;

    return stringNumber;
  }

  public mapToOptions<K>(map: Map<K, string>): {value: K, label: string}[] {
    return Array.from(map, ([value, label]) => ({ value, label }));
  }
}
